// extracted by mini-css-extract-plugin
module.exports = {"container":"description_container__OEx7I","textWrapper":"description_textWrapper__14msD","teploinform":"description_teploinform__ejnLK","ulWrapper":"description_ulWrapper__ZCl-4"};